import axiosClient from './axiosClient';

export default {
  login: (payload) => axiosClient.post('/auth/login', payload),
  register: (payload) => axiosClient.post('/auth/register', payload),
  accettaConsenso: () => axiosClient.post('/users/consenso'),
  // FIX QUI
  me: () => axiosClient.get('/users/me'),

  list: (params) => axiosClient.get('/users', { params }),
  get: (id) => axiosClient.get(`/users/${id}`),
  create: (data) => axiosClient.post('/users', data),
  update: (id, data) => axiosClient.put(`/users/${id}`, data),
  delete: (id) => axiosClient.delete(`/users/${id}`),
  forgotPassword: (username) =>
    axiosClient.post('/auth/password/forgot', { username }),
  resetPassword: (token, newPassword) =>
    axiosClient.post('/auth/password/reset', {
      token,
      newPassword
    }),
};